<template>
  <DxPopup
    :visible="getVisible"
    @hidden="onPopupHide"
    :drag-enabled="false"
    :hide-on-outside-click="popupConfig.hideOnOutsideClick"
    :show-close-button="false"
    :show-title="true"
    :width="'99.99%'"
    :height="'99.99%'"
    :title="popupConfig.title"
    :wrapper-attr="wrapperAttr"
    ref="gc-popup"
    @shown="onShown"
    @initialized="onInitialized"
    :fullScreen="false"
  >
    <DxToolbarItem
      v-if="popupConfig.formMode !== 'create' && popupConfig.secondaryTitle"
      location="before"
      :html="`<span class='toolbar-title-secondary text-secondary'> ${popupConfig.secondaryTitle}</span>`"
    ></DxToolbarItem>
    <DxToolbarItem
      v-for="(item, index) in getToolbarItems"
      :key="index"
      :widget="item.widget"
      :location="item.location"
      :visible="item.visible"
      :toolbar="item.position"
      :options="item.options"
      :template="item.template ? item.template : null"
    />

    <template #screen-pdf-view>
      <gcScreenPdfView
        :buttonColor="'#e8f7f9'"
        :screenName="'Work Orders'"
        :onPreviewPDF="onPreviewPDF"
        v-if="IsFormLoaded && popupConfig.formMode === 'review'"
      />
    </template>

    <template #wo-status-template>
      <gc-status-chip :status="FriendlyStatus" v-if="FriendlyStatus" />
    </template>

    <transition name="expand">
      <div
        class="css-v2 gc-popup-form"
        v-if="popupConfig.isPopupShow"
        v-show="!IsGridExpanded"
      >
        <div
          class="wo-data-header"
          v-bind:class="{ 'core-instance': WorkOrderInstance === 'Core' }"
        >
          <div class="section-1">
            <gc-form
              :key="popupConfig.formKey"
              :form-options="{
                gcLabelLocation: 'left',
              }"
              ref="gc-header-form"
              :form-items="getHeaderFormItems"
              :is-normal="true"
              :data-model="model"
              :form-mode="popupConfig.formMode"
              :from-from="'gc-header-form-d-a'"
              :form-height="245"
              v-if="IsFormLoaded"
            />
          </div>
          <div class="section-2">
            <dx-data-grid
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection2Columns"
              :data-source="getHeaderSection2DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="320"
              @cell-prepared="onHeaderSection2CellPrepared"
              ref="header-section-2-grid"
            >
            </dx-data-grid>
          </div>
          <div class="section-3">
            <dx-data-grid
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection3Columns"
              :data-source="getHeaderSection3DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="WorkOrderInstance === 'Almondco' ? 320 : 'auto'"
              @cell-prepared="onHeaderSection3CellPrepared"
              ref="header-section-3-grid"
            >
            </dx-data-grid>
            <dx-data-grid
              v-if="WorkOrderInstance === 'Core'"
              @toolbar-preparing="onToolbarPreparing($event)"
              :columnChooser="{
                enabled: false,
              }"
              :pager="{ visible: false }"
              :columns="getHeaderSection3Part2Columns"
              :data-source="getHeaderSection3Part2DataSource"
              :row-alternation-enabled="true"
              :repaint-changes-only="true"
              :show-borders="true"
              :two-way-binding-enabled="false"
              :height="WorkOrderInstance === 'Almondco' ? 320 : 105"
              ref="header-section-3-grid"
              :element-attr="{
                class: 'header-section-3-part2-grid',
              }"
              @cell-prepared="onHeaderSection3Part2CellPrepared"
            >
            </dx-data-grid>
          </div>
        </div>

        <gc-form
          :key="popupConfig.formKey"
          :form-options="{
            gcLabelLocation: 'top',
          }"
          ref="gc-header-form-comment"
          :form-items="getHeaderComment"
          :is-normal="true"
          :data-model="model"
          :form-mode="popupConfig.formMode"
          :from-from="'gc-header-form-d-a'"
          :form-height="110"
          v-if="IsFormLoaded"
        />
      </div>
    </transition>

    <div style="background-color: white" class="wo-data-details">
      <DxToolbar class="wo-so-toolbar" v-if="IsFormLoaded">
        <DxItem
          :options="{
            width: 'auto',
            dataSource: getTabViews,
            selectedIndex: selectedTabIndex,
            onItemClick: handleTabClick,
          }"
          location="before"
          widget="dxTabs"
        />

        <DxItem
          :options="{
            icon: IsGridExpanded ? 'collapse' : 'expand',
            text: '',
            elementAttr: {
              class: 'expand-btn',
            },
            onClick: onExpandGrid,
          }"
          location="after"
          locate-in-menu="auto"
          widget="dxButton"
        />
      </DxToolbar>

      <div class="wo-so-lines">
        <!-- Sale Orders Grid  -->
        <dx-data-grid
          v-if="IsFormLoaded"
          @toolbar-preparing="onToolbarPreparing($event)"
          :columnChooser="{
            enabled: false,
          }"
          :pager="{ visible: false }"
          :columns="getSalesGridColumns"
          :data-source="getLocalDataSource"
          :row-alternation-enabled="true"
          :selection="{
            mode: 'none',
          }"
          :height="gridHeight"
          :ref="'wo-so-line-grid'"
          @content-ready="onContentReady"
          @initialized="onGridInitialized"
        >
          <DxEditing
            :allow-deleting="false"
            :allow-updating="false"
            :mode="'cell'"
          />
          <DxRowDragging
            :allow-reordering="isEditable"
            :show-drag-icons="isEditable"
            :on-reorder="onRowReorder"
          />
          <template #Record="{ data }">
            <GcRecord
              :data="data"
              :primary="data.column['cellTemplateRecord']['primary']"
              :secondary="data.column['cellTemplateRecord']['secondary']"
            />
          </template>
          <template #Status="{ data }">
            <GcStatusChip
              :status="data.data[data.column.dataField]"
              v-if="data.data[data.column.dataField]"
              :customBackGroundColor="
                data.column.customBackGroundColor
                  ? data.column.customBackGroundColor
                  : undefined
              "
              :data="data.data"
            />
          </template>

          <template #Decimal="{ data }">
            <GcDecimal :dataValue="data" :format="data.column.format" />
          </template>
        </dx-data-grid>
      </div>
    </div>

    <GcPopupAudit
      v-if="popupAuditVisible"
      :showPopup.sync="popupAuditVisible"
      :model.sync="auditModel"
    />
  </DxPopup>
</template>
<script>
import { TransactionReportService } from "@/_services/api/reports/transaction-report.service";
import ApiService from "@/_services/api/api.service";
import { getGlobalField } from "@/_store/helpers";
import { b64toBlob } from "@/_helpers/pdf/pdf-helper";

import { WorkOrderService } from "../../_services/api/production/work-order.service";
import SettingsService from "../../_services/api/settings/graycorp/settings.service";
import { mapGetters } from "vuex";
import ArrayStore from "devextreme/data/array_store";
import DataGridMixin from "@/_mixins/data-grid.mixin";
import ColumnWidth from "../../_helpers/data-grid/ColumnWidth";
import { formatNumber } from "devextreme/localization";

import gcScreenPdfView from "../../components/common/gc-screen-pdf-view.vue";
import { DxRowDragging } from "devextreme-vue/data-grid";
import { ProductionCalendarLinkedSOService } from "../../_services/api/production/production-calendar-linked-so";
import { FeatureStorage } from "../../_services/storage";

const defaultProductionSummary = () => ({
  AddInProductionUMQty: 0.0,
  AddInStockUMQty: 0.0,
  MTSProductionMQty: 0.0,
  MTSStockUMQty: 0.0,
  ReleasedProductionUMPercent: 0.0,
  ReleasedProductionUMQty: 0.0,
  ReleasedStockUMPercent: 0.0,
  ReleasedStockUMQty: 0.0,
  SalesOrderProductionUMQty: 0.0,
  SalesOrderStockUMQty: 0.0,
  WorkOrderProductionUMQty: 0.0,
  WorkOrderStockUMQty: 0.0,
  ProductionUM: "",
  StockUM: "",
  VarianceStockUMPercent: 0.0,
  VarianceStockUMQty: 0.0,
  SendToProductionStockUMQty: 0.0,
  SendToProductionProductionUMQty: 0.0,
  VarianceProductionUMQty: 0.0,
  VarianceProductionUMPercent: 0.0,
});

const defaultMaterialSummary = () => ({
  BiProduct: 0.0,
  BiProductPercent: 0.0,
  LossGainPercent: 0.0,
  LossGainStockUMQty: 0.0,
  MaterialAddedIn: 0.0,
  MaterialIssued: 0.0,
  MaterialReturned: 0.0,
  BrownReclaimPercent: 0.0,
  BrownReclaimStockUMQty: 0.0,
  WhiteReclaimPercent: 0.0,
  WhiteReclaimStockUMQty: 0.0,
  Rubbish: 0.0,
  StockUM: "",
});

const defaultCostSummary = () => ({
  FullManufacturedActualCost: 0,
  FullManufacturedPlannedCost: 0,
  FullManufacturedVarianceCost: 0,
  FullManufacturedVariancePercent: 0,
  LabourActualCost: 0,
  LabourPlannedCost: 0,
  LabourVarianceCost: 0,
  LabourVariancePercent: 0,
  MaterialsActualCost: 0,
  MaterialsPlannedCost: 0,
  MaterialsVarianceCost: 0,
  MaterialsVariancePercent: 0,
  ProcessCode: "",
  ProductionUMActualCost: 0,
  ProductionUMPlannedCost: 0,
  ProductionUMVarianceCost: 0,
  ProductionUMVariancePercent: 0,
  StockUM: "",
  StockUMActualCost: 0,
  StockUMPlannedCost: 0,
  StockUMVarianceCost: 0,
  StockUMVariancePercent: 0,
  WorkOrderCode: 0,
});

export default {
  mixins: [DataGridMixin],
  components: {
    gcScreenPdfView,
    DxRowDragging,
  },
  data() {
    return {
      popupAuditVisible: false,
      auditModel: {
        createdBy: "",
        dateCreated: "",
        changedBy: "",
        dateChanged: "",
      },
      FriendlyStatus: "Draft",
      model: {
        BomCode: null,
        Branch: null,
        QuoteCode: 0,
        Code: 0,
        Comments: "",
        CompanyCode: "",
        Division: null,
        Product: null,
        Quantity: 0,
        Required: new Date(),
        Scheduled: new Date(),
        DateIn: new Date(),
        MTSQuantity: 0,
        SOQuantity: 0,
        ReleasedQty: 0,
        AddInSalesUMQuantity: 0,
        AddInStockUMQuantity: 0,
        ReleaseDepartment: null,
        SchedulingMethod: null,
      },
      IsFormLoaded: false,

      Status: "D",

      HotKeyWatcherEnabled: true,
      WorkOrderInstance: "Core",

      StatusComponent: null,
      headerSection2DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      headerSection3DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      headerSection3Part2DataSource: new ArrayStore({
        key: "ID",
        data: [],
      }),
      gridHeight: "auto",

      ProductionSummary: defaultProductionSummary(),
      MaterialSummary: defaultMaterialSummary(),
      CostSummary: defaultCostSummary(),
      refreshOnUpdate: false,
      IsBOMDisabled: false,
      IsGridExpanded: false,
      selectedTabIndex: 0,
      soLinesDataSource: new ArrayStore({
        key: ["SalesOrderCode", "SalesOrderLine"],
        data: [],
      }),
    };
  },
  props: {
    popupConfig: {
      type: Object,
      default: () => {},
    },
    onToolbarMenuItemOnClick: {
      type: Function,
      default: () => {},
    },
    wrapperAttr: {
      type: Object,
      default: () => {},
    },
    onHide: {
      type: Function,
      default: () => [],
    },
    width: {
      type: Number,
      default: 300,
    },
    height: {
      type: Number,
      default: 600,
    },
    dataModel: {
      type: Object,
      default: () => {},
    },
    applicationFeatureCode: {
      type: String,
      default: "WorkOrder",
    },
    showLoading: {
      type: Function,
      default: () => {},
    },
    saveCallBack: {
      type: Function,
      default: () => {},
    },
    displayServerError: {
      type: Function,
      default: function () {},
    },
    displayValidationSummary: {
      type: Function,
      default: function () {},
    },
  },
  async created() {
    let workOrderInstanceSetting = await SettingsService.getBySettingNameFromDb(
      "WorkOrderInstance",
    );

    if (workOrderInstanceSetting.data.value.length > 0) {
      this.WorkOrderInstance =
        workOrderInstanceSetting.data.value[0].SettingValue;
    }

    await this.setHeaderSection2DataSource();
    await this.setHeaderSection3DataSource();

    if (this.popupConfig.calendarDate) {
      this.model.Required = new Date(this.popupConfig.calendarDate);
    }

    if (
      this.popupConfig.workOrderCode &&
      this.popupConfig.formMode === "review"
    ) {
      this.showLoading(true);

      if (this.popupConfig.formMode === "review") {
        await this.getWorkOrderHeaderSummary(this.popupConfig.workOrderCode);
      }

      const workOrderDetail = this.dataModel;

      this.model.ReleasedQty = workOrderDetail.ActualQty;
      this.model.BomCode = workOrderDetail.BomCode;
      this.model.Branch = workOrderDetail.BranchCode;
      this.model.Code = workOrderDetail.Code;
      this.model.Comments = workOrderDetail.Comment;
      this.model.CompanyCode = workOrderDetail.CompanyCode;
      this.model.Division = workOrderDetail.DivisionCode;
      this.model.Product = workOrderDetail.ProductCode;
      this.PrimaryProduct = workOrderDetail.ProductCode;
      this.model.Quantity = workOrderDetail.ItemQty;
      this.model.MTSQuantity = workOrderDetail.MTSQuantity;
      this.model.SOQuantity = workOrderDetail.SalesOrderStockUMQuantity;
      this.model.ReleaseDepartment =
        workOrderDetail.ReleaseDepartmentCode +
        " - " +
        workOrderDetail.ReleaseDepartmentName;
      this.Status = workOrderDetail.Status;
      this.model.SchedulingMethod = workOrderDetail.SchedulingMethod;

      this.MTSQuantityForCopy = workOrderDetail.MTSQuantity;

      this.auditModel.createdBy = this.dataModel.CreatedBy;
      this.auditModel.dateCreated = this.dataModel.DateCreated;
      this.auditModel.changedBy = this.dataModel.ChangedBy;
      this.auditModel.dateChanged = this.dataModel.DateChanged;
      this.auditModel.dateCompleted = this.dataModel.DateCompleted;

      this.model.QuoteCode = workOrderDetail.QuoteCode;
      this.model.Required = new Date(workOrderDetail.ShipDate.replace("Z", ""));
      this.model.Scheduled = new Date(
        workOrderDetail.ScheduledDate.replace("Z", ""),
      );

      if (workOrderDetail.PlannedCompletionDate) {
        this.model.PlannedCompletionDate = new Date(
          workOrderDetail.PlannedCompletionDate.replace("Z", ""),
        );
      }

      await this.getWOSalesOrderLines(workOrderDetail.Code);

      if (
        this.FriendlyStatus === "Cancelled" ||
        this.FriendlyStatus === "Completed"
      ) {
        this.popupConfig.isEditable = false;
      } else {
        this.popupConfig.isEditable = true;
      }

      this.IsFormLoaded = true;

      this.$nextTick(async () => {
        this.calculateAddInHeaderValues();
        this.showLoading(false);
      });
    }

    if (this.popupConfig.formMode != "review") {
      this.getWorkOrderStatus();
    }
  },
  methods: {
    async getWOSalesOrderLines(code) {
      await WorkOrderService.getWOSOLines(code).then((res) => {
        res.data.value.forEach((element) => {
          element.SalesUMQuantity = element.SalesOrderSalesUMQuantity;
          element.StockUMQuantity = element.SalesOrderStockUMQuantity;
          element.SalesOrderShipDate = new Date(
            element.SalesOrderShipDate.replace("Z", ""),
          );
          this.soLinesDataSource.insert(element);
        });
      });
    },
    updateHeaderSection2Values() {
      if (this.popupConfig.formMode !== "review") {
        if (this.model.Quantity !== this.initialTotalQuantity) {
          this.isQuantityChanged = true;
        }

        this.ProductionSummary.MTSStockUMQty = this.model.MTSQuantity;
        this.ProductionSummary.MTSProductionMQty =
          this.model.MTSQuantity / this.AddInSalesUMConversion;

        this.ProductionSummary.AddInStockUMQty =
          this.model.AddInStockUMQuantity;
        this.ProductionSummary.AddInProductionUMQty =
          this.model.AddInSalesUMQuantity;

        this.ProductionSummary.SalesOrderStockUMQty = this.model.SOQuantity;
        this.ProductionSummary.SalesOrderProductionUMQty =
          this.model.SOQuantity / this.AddInSalesUMConversion;

        this.ProductionSummary.WorkOrderStockUMQty = this.model.Quantity;
        this.ProductionSummary.WorkOrderProductionUMQty =
          this.model.Quantity / this.AddInSalesUMConversion;

        this.resetAndRefreshHeaderTotals(true);
      }
    },
    async setHeaderSection2DataSource() {
      this.headerSection2DataSource.clear();
      this.headerSection2DataSource.insert({
        Title: "MTS Qty",
        StockUMQty: this.ProductionSummary.MTSStockUMQty,
        ProductionUMQty: this.ProductionSummary.MTSProductionMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Add In Qty",
        StockUMQty: this.ProductionSummary.AddInStockUMQty,
        ProductionUMQty: this.ProductionSummary.AddInProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "SO Qty",
        StockUMQty: this.ProductionSummary.SalesOrderStockUMQty,
        ProductionUMQty: this.ProductionSummary.SalesOrderProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "WO Qty",
        StockUMQty: this.ProductionSummary.WorkOrderStockUMQty,
        ProductionUMQty: this.ProductionSummary.WorkOrderProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Released Qty",
        StockUMQty: this.ProductionSummary.ReleasedStockUMQty,
        ProductionUMQty: this.ProductionSummary.ReleasedProductionUMQty,
      });

      this.headerSection2DataSource.insert({
        Title: "Variance",
        StockUMQty: 0,
        ProductionUMQty: 0,
        VarianceStockUMQty: this.ProductionSummary.VarianceStockUMQty,
        VarianceProductionUMQty: this.ProductionSummary.VarianceProductionUMQty,
      });

      if (this.WorkOrderInstance === "Almondco") {
        this.headerSection2DataSource.insert({
          Title: "Send to Production",
          StockUMQty: this.ProductionSummary.SendToProductionStockUMQty,
          ProductionUMQty:
            this.ProductionSummary.SendToProductionProductionUMQty,
        });
      } else {
        this.headerSection2DataSource.insert({
          Title: "",
          StockUMQty: 0,
          ProductionUMQty: 0,
          VarianceStockUMPercent: this.ProductionSummary.VarianceStockUMPercent,
          VarianceProductionUMPercent:
            this.ProductionSummary.VarianceProductionUMPercent,
        });
      }
    },
    async setHeaderSection3DataSource() {
      this.headerSection3DataSource.clear();

      if (this.WorkOrderInstance === "Almondco") {
        this.headerSection3DataSource.insert({
          Title: "Material Issued",
          Weight: this.MaterialSummary.MaterialIssued,
          Value: null,
        });
        this.headerSection3DataSource.insert({
          Title: "Material Added In",
          Weight: this.MaterialSummary.MaterialAddedIn,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Material Returned",
          Weight: this.MaterialSummary.MaterialReturned,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Bi-Product",
          Weight: this.MaterialSummary.BiProduct,
          Value: this.MaterialSummary.BiProductPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Rubbish",
          Weight: this.MaterialSummary.Rubbish,
          Value: null,
        });

        this.headerSection3DataSource.insert({
          Title: "Brown Reclaim",
          Weight: this.MaterialSummary.BrownReclaimStockUMQty,
          Value: this.MaterialSummary.BrownReclaimPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "White Reclaim",
          Weight: this.MaterialSummary.WhiteReclaimStockUMQty,
          Value: this.MaterialSummary.WhiteReclaimPercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Loss / Gain",
          Weight: this.MaterialSummary.LossGainStockUMQty,
          Value: this.MaterialSummary.LossGainPercent,
        });
      } else {
        this.setHeaderSection3Part2DataSource();
        this.headerSection3DataSource.insert({
          Title: "Materials",
          PlannedCost: this.CostSummary.MaterialsPlannedCost,
          ActualCost: this.CostSummary.MaterialsActualCost,
          Variance: this.CostSummary.MaterialsVarianceCost,
          VariancePercentage: this.CostSummary.MaterialsVariancePercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Labour",
          PlannedCost: this.CostSummary.LabourPlannedCost,
          ActualCost: this.CostSummary.LabourActualCost,
          Variance: this.CostSummary.LabourVarianceCost,
          VariancePercentage: this.CostSummary.LabourVariancePercent,
        });

        this.headerSection3DataSource.insert({
          Title: "Full Manufactured",
          PlannedCost: this.CostSummary.FullManufacturedPlannedCost,
          ActualCost: this.CostSummary.FullManufacturedActualCost,
          Variance: this.CostSummary.FullManufacturedVarianceCost,
          VariancePercentage: this.CostSummary.FullManufacturedVariancePercent,
        });
      }
    },
    setHeaderSection3Part2DataSource() {
      this.headerSection3Part2DataSource.clear();
      this.headerSection3Part2DataSource.insert({
        Title: "Stock UM",
        PlannedCost: this.CostSummary.StockUMPlannedCost,
        ActualCost: this.CostSummary.StockUMActualCost,
        Variance: this.CostSummary.StockUMVarianceCost,
        VariancePercentage: this.CostSummary.StockUMVariancePercent,
      });
      this.headerSection3Part2DataSource.insert({
        Title: "Production UM",
        PlannedCost: this.CostSummary.ProductionUMPlannedCost,
        ActualCost: this.CostSummary.ProductionUMActualCost,
        Variance: this.CostSummary.ProductionUMVarianceCost,
        VariancePercentage: this.CostSummary.ProductionUMVariancePercent,
      });
    },
    onGridInitialized(e) {
      setTimeout(() => {
        this.$nextTick(() => {
          this.reSizeGrid(e.component);
        });
      }, 100);
    },
    onContentReady(e) {
      this.addGridNoResults(e, {
        addNew: {
          class: "add-new",
          title: "No Sales Orders",
          message: "No orders linked with this Work Order",
        },
      });
      this.setModelItemHeights();
      this.$nextTick(() => {
        this.reSizeGrid(e.component);
      });
    },
    reSizeGrid(component) {
      component.beginUpdate();
      component.updateDimensions();
      component.endUpdate();

      // this.$nextTick(() => {
      //   component.refresh(true);
      // });
    },

    async handleTabClick(e) {
      this.selectedTabIndex = e.itemIndex;
    },
    /**
     * Handle Audit Popup
     */
    onAuditPopupHandler() {
      this.popupAuditVisible = !this.popupAuditVisible;
    },

    /**
     * on popup model shown
     */
    onShown() {
      this.$store.dispatch("hotKey/setHotKeyPopupMode", true);
    },

    /**
     * on pop up model hide
     */
    onPopupHide() {
      this.dataModel.Code = null;
      this.dataModel.WorkOrderCode = null;
      this.dataModel.Branch = null;

      // Reset tracking flags
      this.initialRequiredDate = null;
      this.isRequiredDateChanged = false;
      this.initialTotalQuantity = 0;
      this.isQuantityChanged = false;
      this.isProcessTabChanged = false;

      this.onHide();
      this.$store.dispatch("hotKey/setHotKeyPopupMode", false);
    },

    onInitialized(e) {
      if (this.popupConfig.formMode !== "review")
        e.component.registerKeyHandler("escape", (arg) => {
          arg.stopPropagation();
        });
    },

    /**
     * Preview PDF Report
     */
    async onPreviewPDF(pdfData) {
      if (pdfData) {
        this.showLoading(true);
        var response;
        await TransactionReportService.getByFeatureCode(
          pdfData.ScreenLayoutApplicationFeatureCode,
        )
          .then((res) => {
            response = res;
          })
          .catch((err) => {
            if (err) this.showLoading(false);
            this.$alert("Report repx not found", "Error");
            return;
          });

        var report = undefined;
        if (response && response.data) {
          report = response.data;
          report.Parameters = JSON.parse(response.data.Parameters);

          let link = `/api/GetReportPdf?reportLocation=${report.Location}`;

          report.Parameters.forEach((element) => {
            let globalField = { ...getGlobalField(element.screenField) };

            if (globalField) {
              link += `&${globalField.dataField}=${this.dataModel.Code}`;
            }
          });

          await ApiService.get(link)
            .then((res) => {
              const blob = b64toBlob(res.data, "application/pdf");
              const blobUrl = URL.createObjectURL(blob);
              this.showLoading(false);

              Object.assign(document.createElement("a"), {
                target: "_blank",
                href: blobUrl,
              }).click();
            })
            .catch((error) => {
              this.$logger.debug("ExportToPdf Error ", error);
              this.showLoading(false);
            });
        }
      }
    },

    /**
     * On Save Popup Handler
     */
    async onSavePopupHandler() {},

    /**
     * on Cancel Popup Handler
     */
    async onCancelPopupHandler() {
      if (this.popupConfig.isPopupShow) {
        this.popupConfig.hideOnOutsideClick = true;
        this.popupConfig.formMode = "review";
        this.popupConfig.formKey++;
        this.popupConfig.isPopupShow = false;
      }
    },

    calculateAddInHeaderValues() {
      let addInStockUMQty = 0;
      let addInSalesUMQty = 0;

      addInSalesUMQty = (
        addInStockUMQty / this.AddInSalesUMConversion
      ).roundNumber(4);

      if (this.popupConfig.formMode !== "review") {
        this.model.AddInStockUMQuantity = addInStockUMQty;
        this.model.AddInSalesUMQuantity = addInSalesUMQty;
        this.updateHeaderSection2Values();
      }
    },

    async getWorkOrderHeaderSummary(code) {
      try {
        const response = await WorkOrderService.getWorkOrderHeaderSummary(
          code,
          this.WorkOrderInstance,
        );
        if (response && response.data) {
          this.ProductionSummary = response.data.ProductionSummary;
          this.MaterialSummary = response.data.MaterialSummary;
        }

        this.resetAndRefreshHeaderTotals(true);
      } catch (error) {
        this.displayServerError(error, "Failed to fetch Work Order Summary");
      } finally {
        if (this.WorkOrderInstance === "Core") {
          this.getWorkOrderCostSummary(code);
        }
      }
    },

    async getWorkOrderCostSummary(code) {
      try {
        const response = await WorkOrderService.getWorkOrderCostSummary(code);
        if (response && response.data && response.data.value.length > 0) {
          this.CostSummary = response.data.value[0];
        }
      } catch (error) {
        this.displayServerError(
          error,
          "Failed to fetch Work Order Cost Summary",
        );
      } finally {
        this.resetAndRefreshHeaderTotals(true);
      }
    },

    resetAndRefreshHeaderTotals(refresh = false) {
      this.headerSection2DataSource.clear();
      this.headerSection3DataSource.clear();
      this.headerSection3Part2DataSource.clear();

      this.$nextTick(async () => {
        await this.setHeaderSection2DataSource();
        await this.setHeaderSection3DataSource();
        const section2Instance = this.$refs["header-section-2-grid"];
        if (section2Instance && section2Instance.instance) {
          if (refresh) {
            section2Instance.instance.refresh(true);
          } else {
            section2Instance.instance.repaint();
          }
          setTimeout(() => {
            section2Instance.instance.updateDimensions();
          }, 100);
        }

        const section3Instance = this.$refs["header-section-3-grid"];
        if (section3Instance && section3Instance.instance) {
          if (refresh) {
            section3Instance.instance.refresh(true);
          } else {
            section3Instance.instance.repaint();
          }
          setTimeout(() => {
            section3Instance.instance.updateDimensions();
          }, 100);
        }

        const section3Part2Instance = this.$refs["header-section-3-part2-grid"];
        if (section3Part2Instance && section3Part2Instance.instance) {
          if (refresh) {
            section3Part2Instance.instance.refresh(true);
          } else {
            section3Part2Instance.instance.repaint();
          }
        }
      });
    },

    onHeaderSection2CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (e.rowIndex > 2) {
          e.cellElement.style.fontWeight = "bold";
        }

        if (
          e.rowIndex === 5 ||
          (e.rowIndex === 6 && this.WorkOrderInstance === "Core")
        ) {
          if (
            (e.columnIndex === 1 && e.data.Variance > 0) ||
            (e.columnIndex === 2 && e.data.VariancePercentage > 0)
          ) {
            e.cellElement.style.color = "#079455";
          } else if (
            (e.columnIndex === 1 && e.data.Variance < 0) ||
            (e.columnIndex === 2 && e.data.VariancePercentage < 0)
          ) {
            e.cellElement.style.color = "red";
          }
        }
      }
    },
    onHeaderSection3CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (this.WorkOrderInstance === "Core") {
          if (e.rowIndex === 2) {
            e.cellElement.style.fontWeight = "bold";
          }

          if (e.columnIndex === 3 || e.columnIndex === 4) {
            if (e.value > 0) {
              e.cellElement.style.color = "#079455";
            } else if (e.value < 0) {
              e.cellElement.style.color = "red";
            }
          }
        } else {
          if (e.rowIndex === 7) {
            e.cellElement.style.fontWeight = "bold";
          }

          if (e.rowIndex === 7) {
            if (
              (e.columnIndex === 1 && e.data.Weight > 0) ||
              (e.columnIndex === 2 && e.data.Value > 0)
            ) {
              e.cellElement.style.color = "#079455";
            } else if (
              (e.columnIndex === 1 && e.data.Weight < 0) ||
              (e.columnIndex === 2 && e.data.Value < 0)
            ) {
              e.cellElement.style.color = "red";
            }
          }
        }
      }
    },
    onHeaderSection3Part2CellPrepared(e) {
      if (e && e.rowType === "data") {
        if (e.columnIndex === 3 || e.columnIndex === 4) {
          if (e.value > 0) {
            e.cellElement.style.color = "#079455";
          } else if (e.value < 0) {
            e.cellElement.style.color = "red";
          }
        }
      }
    },
    setModelItemHeights() {
      this.$nextTick(() => {
        const popupHeight = document.querySelector(
          ".gc-popup-wo-so-sequencing .dx-overlay-content.dx-popup-normal.dx-resizable",
        ).clientHeight;
        const toolBarHeight = document.querySelector(
          ".gc-popup-wo-so-sequencing .dx-toolbar.dx-widget.dx-visibility-change-handler.dx-collection.dx-popup-title",
        ).clientHeight;

        let headerHeight = document.querySelector(
          ".dx-popup-content .css-v2.gc-popup-form",
        ).clientHeight;

        if (this.IsGridExpanded) {
          headerHeight = 0;
        }

        this.gridHeight = popupHeight - toolBarHeight - headerHeight - 60;
      });
    },

    async onExpandGrid() {
      this.IsGridExpanded = !this.IsGridExpanded;
      await this.$nextTick();

      setTimeout(() => {
        this.$nextTick(() => {
          this.setModelItemHeights();
          const dataGridInstance = this.getDataGridInstance;
          if (dataGridInstance) {
            this.reSizeGrid(dataGridInstance);
          }
        });
      }, 100);
    },

    /**
     * on so list grid toolbar preparing
     * @param e - event
     */
    onToolbarPreparing(e) {
      e.toolbarOptions.visible = false;
    },

    onRowReorder(e) {
      let itemData = e.itemData;

      const toIndex = e.toIndex;
      const fromIndex = e.fromIndex;

      const newTasks = [...this.soLinesDataSource._array];

      newTasks.splice(fromIndex, 1);
      newTasks.splice(toIndex, 0, itemData);

      this.soLinesDataSource._array = newTasks;

      this.$nextTick(() => {
        if (!this.getDataGridInstance) return;
        let instance = this.getDataGridInstance;
        if (instance) instance.refresh();
      });
    },

    async onSaveSequenceHandler() {
      const response = await this.saveSequenceOrder();

      if (response) {
        this.saveCallBack();
        this.$emit("hideSequencePopup", true);
        this.$nextTick(() => {
          this.popupConfig.isPopupShow = false;
        });
      }
    },
    async saveSequenceOrder() {
      let errorFree = true;
      const soLines = await this.soLinesDataSource.load();
      const salesOrderLines = soLines.map((line, index) => {
        return {
          RecordId: line.RecordId,
          NewPosition: index + 1,
        };
      });

      this.showLoading(true);
      try {
        const save =
          await ProductionCalendarLinkedSOService.reOrderLinkedSalesOrder({
            ProcessWorkOrderSalesOrderLines: salesOrderLines,
          });

        if (save) {
          this.$notify(
            "Sales Order / Make-to-Stock Sequence saved successfully.",
            "success",
          );
        }
      } catch (error) {
        errorFree = false;
        this.displayServerError(
          error,
          "Failed to save Sales Order / Make-to-Stock Sequence",
        );
      } finally {
        this.showLoading(false);
        // eslint-disable-next-line no-unsafe-finally
        return errorFree;
      }
    },
    async onEditWorkOrderHandler() {
      const response = await this.saveSequenceOrder();

      if (response) {
        this.$nextTick(() => {
          this.$emit("showWorkOrderEdit");
        });
      }
    },
  },
  computed: {
    ...mapGetters({ getHotKeySave: "hotKey/getHotKeySave" }),
    getDataModelForIssuesTab() {
      return {
        WorkOrderCode: this.dataModel.Code,
        BranchCode: this.dataModel.Branch,
        WorkOrderStatus: this.dataModel.FriendlyStatus,
      };
    },

    getTabViews() {
      return [{ id: 0, text: "Sales Order / Make‑to‑Stock Sequence" }];
    },

    getVisible() {
      if (this.popupConfig.isPopupShow) return this.popupConfig.isPopupShow;
      else return false;
    },

    getHeaderFormItems() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              screenField: "BOM",
              dataField: "BomCode",
              required: true,
              label: {
                text: "BOM",
              },
              editorOptions: {
                showClearButton: true,
                readOnly: true,
                select: [
                  "Code",
                  "Comment",
                  "Description1",
                  "Description2",
                  "ProductCode",
                  "BatchSize",
                  "BranchCode",
                  "DivisionCode",
                  "BomTypeCode",
                  "Status",
                ],
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description1}`;
                else return undefined;
              },
            },
            {
              screenField: "Product",
              dataField: "Product",
              allowUpdate: true,
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description1}`;
                else undefined;
              },
            },
            {
              screenField: "Branch",
              dataField: "Branch",
              required: true,
              label: {
                text: "Branch",
              },
              filter: ["ManufactureFlag", "=", "Y"],
              editorOptions: {
                tabIndex: -1,
                readOnly: true,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description}`;
                else undefined;
              },
            },
            {
              screenField: "Division",
              dataField: "Division",
              required: true,
              label: {
                text: "Division",
              },
              editorOptions: {
                tabIndex: -1,
                readOnly: true,
              },
              displayExpr: (e) => {
                if (e) return `${e.Code} - ${e.Description}`;
                else undefined;
              },
            },
            {
              screenField: "DateIn",
              dataField: "Required",
              label: {
                text: "Required",
              },
              format: "dd MMM yyyy",
              editorOptions: {
                showClearButton: true,
                tabIndex: -1,
                useMaskBehavior: true,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
                readOnly: true,
              },
              required: true,
            },
            {
              visible: this.popupConfig.formMode === "review",
              screenField: "DateIn",
              dataField: "Scheduled",
              label: {
                text: "Scheduled",
              },
              format: "dd MMM yyyy",
              editorOptions: {
                tabIndex: -1,
                readOnly: true,
                useMaskBehavior: true,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
              required: true,
            },
            {
              visible:
                this.popupConfig.formMode === "review" ||
                this.popupConfig.formMode === "edit",
              // screenField: "DateIn",
              dataField: "PlannedCompletionDate",
              label: {
                text: "Planned Completion",
              },
              displayFormat: "dd MMM yyyy H:mm aa",
              editorOptions: {
                tabIndex: -1,
                useMaskBehavior: true,
                readOnly: true,
                displayFormat: "dd MMM yyyy H:mm aa",
              },
              required: true,
              type: "datetime",
              editorType: "dxDateBox",
            },
            {
              visible: this.popupConfig.formMode === "review",
              label: {
                text: "Release Department",
              },
              dataField: "ReleaseDepartment",
            },
          ],
        },
      ];
    },
    getHeaderComment() {
      return [
        {
          itemType: "group",
          caption: "",
          colCount: 1,
          items: [
            {
              dataField: "Comments",
              screenField: "Comments",
              allowUpdate: false,
              editorType: "dxTextArea",
              editorOptions: {
                readOnly: true,
                tabIndex: -1,
                height: 80,
                maxLength: 1000,
                onFocusIn: (e) => {
                  e.event.target.select();
                },
              },
            },
          ],
        },
      ];
    },

    getToolbarItems() {
      return [
        {
          widget: "dxButton",
          location: "after",
          toolbar: "center",
          visible: this.popupConfig.formMode === "review",
          cssClass: "status-template-2",
          options: {
            template: "wo-status-template",
            elementAttr: { class: "status-template" },
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: false, // This work is being deferred at this time as legacy does not support background printing of work orders atm. #54380
          options: {
            icon: "print",
            // onClick: this.onBackGrounPrintRequest,
          },
        },
        {
          location: "after",
          toolbar: "top",
          visible: this.popupConfig.formMode === "review",
          template: "screen-pdf-view",
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible:
            this.popupConfig.formMode !== "create" &&
            this.popupConfig.formMode !== "copy",
          options: {
            icon: "clock",
            onClick: this.onAuditPopupHandler,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.isEditable,
          options: {
            text: "Edit WO",
            stylingMode: "contained",
            type: "default",
            onClick: this.onEditWorkOrderHandler,
            visible: this.isEditable,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: this.isEditable,
          options: {
            text: "Save",
            stylingMode: "contained",
            type: "default",
            onClick: this.onSaveSequenceHandler,
            visible: this.isEditable,
          },
        },
        {
          widget: "dxButton",
          location: "after",
          toolbar: "top",
          visible: true,
          options: {
            icon: "close",
            onClick: this.onCancelPopupHandler,
            visible: true,
          },
        },
      ];
    },

    getSalesGridColumns() {
      return this.parseColumnWithScreenFields([
        {
          caption: "Sales Order",
          dataField: "SalesOrderCode",
          width: ColumnWidth.SalesOrderNumber.width - 10,
          minWidth: ColumnWidth.SalesOrderNumber.minWidth - 10,
          alignment: "left",
          allowEditing: false,
        },
        // {
        //   caption: "Position",
        //   dataField: "Position",
        //   width: 80,
        //   minWidth: 80,
        //   allowEditing: false,
        // },
        {
          screenField: "Customer",
          allowSorting: true,
        },
        {
          screenField: "LineComment",
          caption: "Line #",
          dataField: "SalesOrderLine",
          width: ColumnWidth.LineInfo.width - 20,
          minWidth: ColumnWidth.LineInfo.minWidth - 20,
          alignment: "left",
          allowSorting: true,
        },
        {
          screenField: "ShipDate",
          dataField: "SalesOrderShipDate",
          minWidth: ColumnWidth.Date.minWidth,
          width: ColumnWidth.Date.width,
          format: "dd MMM yyyy",
          allowSorting: true,
        },
        {
          screenField: "Product",
          caption: "Product",
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "ProductionUMQuantity",
          caption: "Production UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "ProductionUM",
          dataField: "ProductionUM",
          caption: "Production UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth + 10,
          width: ColumnWidth.UnitOfMeasure.width + 10,
          allowSorting: true,
        },
        {
          screenField: "Quantity",
          dataField: "StockUMQuantity",
          caption: "Stock UM Qty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          allowSorting: true,
        },
        {
          screenField: "StockUM",
          caption: "Stock UM",
          minWidth: ColumnWidth.UnitOfMeasure.minWidth - 5,
          width: ColumnWidth.UnitOfMeasure.width - 5,
          allowSorting: true,
        },
        {
          screenField: "Comment",
          dataField: "SalesOrderNote",
          caption: "Sales Order Notes",
          // cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            readOnly: true,

            // onInitialized: (e) => {
            //   this.commentFieldHeightUpdate(e);
            // },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
        },
        {
          screenField: "Comment",
          dataField: "Note",
          caption: "Work Order Notes",
          cssClass: "edit-cell-textbox-field comment-text",
          editorOptions: {
            onFocusIn: (e) => {
              e.event.target.select();
            },
            onKeyDown: this.onItemCodeKeyDown,
            maxLength: 1000,
            maxHeight: 103,
            height: 30,
            valueChangeEvent: "input",
            onInput: (e) => {
              this.commentFieldHeightUpdate(e);
            },
            onInitialized: (e) => {
              this.commentFieldHeightUpdate(e);
            },
          },
          minWidth: ColumnWidth.Comment.minWidth,
          width: ColumnWidth.Comment.width,
          customizeText: (e) => {
            if (e.value) return e.value.replaceAll("\n", "<br/>\r\n");
            else return "";
          },
          encodeHtml: false,
          cellTemplate: (data, info) => {
            return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
          },
          setCellValue: (newData, value) => {
            newData.Note = value;
            return newData;
          },
        },
        {
          screenField: "TransportStatus",
          width: 100,
          customBackGroundColor: (data) => {
            if (data && data.TransportStatusHexColour)
              return data.TransportStatusHexColour;
            else return undefined;
          },
        },
      ]);
    },
    /**
     * Data Grid
     * @returns {ArrayStore<*, any>}
     */
    getLocalDataSource() {
      return this.soLinesDataSource._array;
    },

    // Header Updates
    getHeaderSection2Columns() {
      return [
        {
          caption: "",
          dataField: "Title",
          minWidth: 120,
          allowSorting: false,
        },
        {
          alignment: "right",
          caption: this.ProductionSummary.StockUM
            ? `Quantity (${this.ProductionSummary.StockUM})`
            : "Quantity (UM)",
          dataField: "StockUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: (data, info) => {
            if (info.rowIndex === 5) {
              return (data.innerHTML = `<div class='variance-template ${
                info.data.VarianceStockUMQty < 0 ? "negative" : ""
              }''>${formatNumber(
                info.data.VarianceStockUMQty,
                "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              )}</div>`);
            } else if (
              info.rowIndex === 6 &&
              this.WorkOrderInstance === "Core"
            ) {
              return (data.innerHTML = `<div class='variance-percent-template ${
                info.data.VarianceProductionUMPercent < 0 ? "negative" : ""
              }''>${formatNumber(
                info.data.VarianceProductionUMPercent,
                "###,###,##0.00 '%';(###,###,##0.00 '%')",
              )}</div>`);
            } else {
              return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
            }
          },
          allowSorting: false,
        },
        {
          alignment: "right",
          caption: this.ProductionSummary.ProductionUM
            ? `Quantity (${this.ProductionSummary.ProductionUM})`
            : "Quantity (UM)",
          dataField: "ProductionUMQty",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          cellTemplate: (data, info) => {
            if (info.rowIndex === 5) {
              return (data.innerHTML = `<div class='variance-template ${
                info.data.VarianceProductionUMQty < 0 ? "negative" : ""
              }'>${formatNumber(
                info.data.VarianceProductionUMQty,
                "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              )}</div>`);
            } else if (
              info.rowIndex === 6 &&
              this.WorkOrderInstance === "Core"
            ) {
              return (data.innerHTML = `<div class='variance-percent-template ${
                info.data.VarianceProductionUMPercent < 0 ? "negative" : ""
              }'>${formatNumber(
                info.data.VarianceProductionUMPercent,
                "###,###,##0.00 '%';(###,###,##0.00 '%')",
              )}</div>`);
            } else {
              return (data.innerHTML = `<div class='comment-cell-template'>${info.text}</div>`);
            }
          },
          allowSorting: false,
        },
      ];
    },
    getHeaderSection2DataSource() {
      return this.headerSection2DataSource._array;
    },

    getHeaderSection3Columns() {
      return this.WorkOrderInstance === "Almondco"
        ? [
            {
              caption: "Totals",
              dataField: "Title",
              minWidth: 110,
              allowSorting: false,
            },
            {
              caption: this.MaterialSummary.StockUM
                ? `Weight (${this.MaterialSummary.StockUM})`
                : "Weight (UM)",
              dataField: "Weight",
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              width: ColumnWidth.Quantity2DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: " ",
              dataField: "Value",
              minWidth: ColumnWidth.Quantity2DecimalPoints.minWidth,
              width: ColumnWidth.Quantity2DecimalPoints.width,
              format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
              allowSorting: false,
            },
          ]
        : [
            {
              caption: "Work Order Costs",
              dataField: "Title",
              minWidth: 115,
              allowSorting: false,
            },
            {
              caption: "Planned",
              dataField: "PlannedCost",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "Actual",
              dataField: "ActualCost",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "Variance",
              dataField: "Variance",
              minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
              width: ColumnWidth.Quantity4DecimalPoints.width,
              format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
              allowSorting: false,
            },
            {
              caption: "",
              dataField: "VariancePercentage",
              minWidth: ColumnWidth.WorkOrderPercentage.minWidth,
              width: ColumnWidth.WorkOrderPercentage.width,
              format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
              allowSorting: false,
            },
          ];
    },
    getHeaderSection3Part2Columns() {
      return [
        {
          caption: "Unit Costs",
          dataField: "Title",
          minWidth: 115,
          allowSorting: false,
        },
        {
          caption: "Planned",
          dataField: "PlannedCost",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "Actual",
          dataField: "ActualCost",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "Variance",
          dataField: "Variance",
          minWidth: ColumnWidth.Quantity4DecimalPoints.minWidth,
          width: ColumnWidth.Quantity4DecimalPoints.width,
          format: "##,###,###,###,##0.0000;(##,###,###,###,##0.0000)",
          allowSorting: false,
        },
        {
          caption: "",
          dataField: "VariancePercentage",
          minWidth: ColumnWidth.WorkOrderPercentage.minWidth,
          width: ColumnWidth.WorkOrderPercentage.width,
          format: "###,###,##0.00 '%';(###,###,##0.00 '%')",
          allowSorting: false,
        },
      ];
    },
    getHeaderSection3DataSource() {
      return this.headerSection3DataSource._array;
    },
    getHeaderSection3Part2DataSource() {
      return this.headerSection3Part2DataSource._array;
    },
    getDataGridInstance() {
      return this.$refs["wo-so-line-grid"].instance;
    },

    isEditable() {
      return this.userPermission && this.popupConfig.isEditable;
    },

    userPermission() {
      return FeatureStorage.checkPermission("WorkOrder", "create");
    },
  },
  watch: {
    getHotKeySave: {
      handler(val) {
        if (val && this.HotKeyWatcherEnabled) {
          this.$store.dispatch("hotKey/setHotKeySave", false);
          if (this.popupConfig.formMode !== "review") {
            this.onSavePopupHandler();
          }
        }
      },
      deep: true,
    },

    IsFormLoaded: {
      handler(val) {
        if (val) {
          setTimeout(() => {
            this.setModelItemHeights();
          }, 500);
        }
      },
      immediate: true,
    },
  },
};
</script>
<style lang="scss">
.gc-popup-wo-so-sequencing {
  .hyperlink.negative a {
    color: red !important;
  }

  .hyperlink.zero a {
    color: black !important;
  }
  .status-template {
    display: flex;
    align-items: center;
  }
  .dx-toolbar.dx-popup-title {
    height: 60px;
  }

  .toolbar-title-secondary {
    padding-left: unset !important;
    font-weight: 400;
    font-size: 14px;
  }

  .wo-data-details {
    background-color: unset !important;
    margin: 0px 10px;
    padding-top: 10px;

    .wo-so-toolbar {
      .add-new-btn {
        .dx-button {
          background-color: unset !important;
          .dx-button-content .dx-icon::before {
            color: #344054 !important;
          }

          .dx-button-text {
            padding-right: unset !important;
          }
        }

        margin-right: 10px;
        background: var(
          --Component-colors-Components-Buttons-Secondary-button-secondary-bg,
          #ffffff
        );
        border: 1px solid
          var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-border,
            #d0d5dd
          );
        box-shadow: 0px 1px 2px 0px #1018280d;

        .dx-icon.dx-icon-plus::before {
          color: #344054 !important;
        }

        .dx-button-text {
          font-family: Inter;
          font-weight: 600;
          font-size: 12px;
          // line-height: 20px;
          letter-spacing: 0%;
          color: var(
            --Component-colors-Components-Buttons-Secondary-button-secondary-fg,
            #344054
          );
        }
      }
    }
  }

  .wo-so-lines {
    .dx-datagrid-header-panel {
      height: 0px !important;
    }
  }
  .wo-materials-grid {
    .dx-datagrid-checkbox-size {
      vertical-align: top !important;
    }
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:not(.dx-validation-pending):not(.dx-datagrid-select-all) {
    vertical-align: top !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    > td:first-of-type:not(.dx-command-expand) {
    padding-left: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-command-select.dx-editor-cell {
    padding-left: 5px !important;
    padding-right: 5px !important;
  }

  .process-code {
    padding-left: 10px !important;
  }

  .os-qty {
    padding-right: 10px !important;
  }

  .dx-datagrid
    .dx-datagrid-content
    .dx-datagrid-table
    .dx-row
    .dx-editor-cell.dx-focused {
    padding-right: 5px !important;
    padding-left: 5px !important;
  }

  .wo-data-header {
    background-color: white;
    padding: 12px;
    display: flex;
    justify-content: space-between;
    gap: 10px;

    > div {
      // width: 100%;

      .dx-datagrid-header-panel {
        height: 0px !important;
      }

      .dx-scrollable-wrapper > .dx-scrollable-container {
        overflow-y: hidden !important;
      }
    }

    .section-1 {
      width: 40%;

      // overflow: hidden;
      -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12),
        0 1px 2px rgba(0, 0, 0, 0.24);
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      border-radius: 2px;
      background-color: #fff;
    }

    .section-2,
    .section-3 {
      width: 30%;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .header-section-3-part2-grid {
      .dx-header-row {
        td {
          height: 35px !important;
          padding-top: 8px !important;
          padding-bottom: 8px !important;
        }
      }
    }
  }
  .variance-template,
  .variance-percent-template {
    color: green;

    &.negative {
      color: red;
    }
  }

  .wo-data-header.core-instance {
    .section-1 {
      width: 35% !important;
    }
    .section-2 {
      width: 25% !important;
    }

    .section-3 {
      width: 40% !important;
    }
  }

  .section-1 {
    border: 1px solid var(--Colors-Border-border-primary, #d0d5dd);
  }

  .expand-enter-active,
  .expand-leave-active {
    transition: all 0.5s ease;
    overflow: hidden;
  }

  .expand-enter,
  .expand-leave-to {
    opacity: 0;
    max-height: 0;
    transform: scaleY(0.95);
  }

  .expand-enter-to,
  .expand-leave {
    opacity: 1;
    max-height: 1000px; // adjust if form is larger
    transform: scaleY(1);
  }

  .gc-popup-form {
    padding-bottom: 0px !important;
  }
}
</style>
